module.exports = __webpack_public_path__ + "static/media/icon-bill.b3e5d677.svg";